import React from "react";
import InputContainer from "./InputContainer";

const MyTextField = React.forwardRef((props, ref) => {
  const {
    label,
    name,
    placeholder,
    multiline,
    rows,
    error,
    size,
    onCustomChange,
    onFileChange,
    watch,
    mode,
    setValue,
    control,
    rules,
    className = "",
    inputClassName = "",
    noSpinner,
    hideSpin,
    ...otherProps
  } = props;

  const isNoSpinner =
    noSpinner ||
    hideSpin ||
    (typeof className === "string" && className.includes("no-spinner")) ||
    (typeof inputClassName === "string" && inputClassName.includes("no-spinner"));

  return (
    <InputContainer {...props} className={className} label={label} error={error} size={size}>
      <input
        ref={ref}
        type="number"
        step="0.1"
        name={name}
        placeholder={placeholder}
        {...otherProps}
        className={`form-control ${inputClassName} ${isNoSpinner ? "no-spinner" : ""}`.trim()}
      />
    </InputContainer>
  );
});
export default MyTextField;


